<app-page-header [heading]="'Tax Report'" [icon]="'fa-calendar'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-4">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label>Location</label>
      <ngx-select-dropdown (change)="getState()" [(ngModel)]="state_data"
                           [config]="utils.dropConfig({displayKey: 'STATE_NAME',placeholder: 'Select Location',searchOnKey: 'STATE_NAME'})"
                           [multiple]="false" [options]="state_options" class="form-control select-dropdown"
                           name="state"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-4">
      <label>VAT %</label>
      <input [(ngModel)]="rate" class="form-control" id="rate" name="rate" type="text">
    </div>
    <div class="form-group col-lg-4">
      <label></label><br>
      <button (click)="listTaxReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;
      </button>&nbsp;
    </div>
    <div class="text-right col-lg-12 pull-right">
        <button *ngIf="(stock_data | json) != '[]'" (click)="ExportToExcel()" class="btn btn-info btn-sm"
            title="Export as XLSX">Export to XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
        <app-report-pdf *ngIf="(stock_data | json) != '[]'"  targetId="printReport" fileName="Tax_Report.pdf" titleName="TAX REPORT"></app-report-pdf>
    </div>
    <div class="col-12" id="printReport">
      <table #table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <thead>
        <tr class="text-center">
          <th width="5%">Sl</th>
          <th class="text-left" width="25%">Item Name</th>
          <th class="text-left" width="10%">HSN Code</th>
          <th class="text-center" width="10%">VAT (%)</th>
          <th class="text-right" width="10%">Taxable Value</th>
          <th class="text-right" width="10%">VAT</th>
        </tr>
        <tr *ngIf="(stock_data | json) == '[]'">
          <td class="text-center" colspan="13">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stock of stock_data;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td class="text-left"> {{ stock.TRADE_NAME }}</td>
          <td class="text-left"> {{ stock.HSN_CODE }}</td>
          <td class="text-center"> {{ stock.VAT }}</td>
          <td class="text-right"> {{ stock.PRICE }}</td>
          <td class="text-right"> {{ stock.SALE_VAT_AMOUNT }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
